import React from "react";

export default function CoinSkeleton() {

  return (
    <div>
      <style>
        {`  @keyframes shimmer {
    0%   { background-position: -400px 0; }
    100% { background-position:  400px 0; }
  }

  .sk {
    background: linear-gradient(
      90deg,
      #ddd6fe 25%,
      #c4b5fd 50%,
      #ddd6fe 75%
    );
    background-size: 400px 100%;
    animation: shimmer 1.5s infinite linear;
    border-radius: 6px;
  }

  .badge {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* Circle icon placeholder */
  .sk-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  /* Number text placeholder */ 
  .sk-number {
    width: 40px;
    height: 15px;
    border-radius: 5px;
  }
        `}
      </style>

      <div className="badge">
        <div className="sk sk-icon"></div>
        <div className="sk sk-number"></div>
      </div>
    </div>
  );
}
